import React from 'react';
import { connect } from 'react-redux';
import {getRaceDetails, selectEvent, syncFavorites, performSearch, switchRace, getResults} from '../actions/race';
import Loading from './Loading';
import PlayIcon from '../icons/play';

class MobileDivisionResults extends React.Component {

  constructor(props, context) {
    super(props, context);
  }

  state = {
    division: null,
    loading: false
  };

  componentWillMount() {
    // this.props.getResults(0, this.props.match.params.raceId);
    // console.log(this.props.match.params);
    this.props.performSearch('', this.props.match.params.division, 0, this.props.match.params.eventId, this.props.match.params.raceId);
  }

  componentDidMount() {

    this.props.syncFavorites(this.props.match.params.raceId);
    if (this.props.match.params.raceId) {
      this.props.getRaceDetails(this.props.match.params.raceId);
      // this.props.getResults(0, this.props.match.params.raceId);
    }

  }

  componentDidUpdate(oldProps){

    if (this.props.match.params.raceId !== oldProps.match.params.raceId) {
      this.props.switchRace(this.props.match.params.raceId);
      // this.props.getResults(0, this.props.match.params.raceId);

    }

    if (this.props.scrollShowMore !== oldProps.scrollShowMore && this.props.scrollShowMore) {
      this.setState({loading: true});
      this.props.performSearch('', this.props.match.params.division, this.props.resultsPage + 1 || 0, this.props.match.params.eventId, this.props.match.params.raceId);
    }

    if (this.props.collectiveResults !== oldProps.collectiveResults) {
      this.setState({loading: false});
      this.props.resetScrollShowMore();
    }
  }

  render() {

    // console.log(this.props.collectiveResults);
    const {raceDetail} = this.props;

    if (!raceDetail || !raceDetail.name) return null;

    // console.log(this.props);
    return (
      <div>
        <div className="header">
          <h5 className="title" style={{backgroundColor: this.props.color}}>{raceDetail.name}</h5>

          <div className="info-block clearfix">
            <h3>Results</h3>

            <a href={`#/race/${raceDetail.race_id}`} className="btn menubutton">Menu</a>
          </div>
        </div>

        {this.props.collectiveResults === null || this.props.collectiveResults === undefined ? (
          <Loading />
        ) : (
          <ul id="results-container">
            {this.props.collectiveResults && this.props.collectiveResults.map((runner, idx) => (
              <div key={idx} className="entry">
                <div className="entry-inner clearfix">
                  <a href={`#/race/${raceDetail.race_id}//${runner.$KEY}`}>
                    <div className="entry-text">
                      <span className="results-index">
                        {idx+1}
                      </span>
                      <span className="results-name">
                          {runner.$TEAM_NAME ? runner.$TEAM_NAME : `${runner.$FIRST_NAME} ${runner.$LAST_NAME}`}
                      </span>
                    </div>
                    <p className="entry-time">{runner.$FINALTM}</p>
                  </a>
                </div>
              </div>
            ))}
            {this.state.loading && this.props.collectiveResults && this.props.collectiveResults.length > 0 &&
              <li><div className="entry"><div className="entry-inner clearfix"><div style={{textAlign: "center"}}>Loading...</div></div></div></li>
            }
          </ul>
            )}
      </div>
    );

  }
}

function mapStateToProps(state) {
  return {
    raceDetail: state.rr360.raceDetail,
    results: state.rr360.searchResults,
    resultsTotal: state.rr360.searchResultsTotal,
    resultsPage: state.rr360.searchResultsPage,
    color: state.rr360.theme.primaryColor,
    collectiveResults: state.rr360.collectiveSearchResults
  };
}


export default connect(mapStateToProps, {getRaceDetails, selectEvent, syncFavorites, performSearch, switchRace, getResults})(MobileDivisionResults);



// WEBPACK FOOTER //
// ./src/components/MobileDivisionResults.js